import { composeDecorators } from 'draft-js-plugins-editor'
import createImagePlugin from 'draft-js-image-plugin'
import createAlignmentPlugin from 'draft-js-alignment-plugin'
import createFocusPlugin from 'draft-js-focus-plugin'
import createBlockDndPlugin from 'draft-js-drag-n-drop-plugin'
import createResizeablePlugin from 'draft-js-resizeable-plugin'
import createInlineToolbarPlugin from 'draft-js-inline-toolbar-plugin'
import createLinkPlugin from 'draft-js-anchor-plugin'

import {
  BoldButton,
  ItalicButton,
  UnderlineButton,
  BlockquoteButton,
} from 'draft-js-buttons'

const linkPlugin = createLinkPlugin({ linkTarget: '_blank' })
const resizeablePlugin = createResizeablePlugin()
const focusPlugin = createFocusPlugin()
const blockDndPlugin = createBlockDndPlugin()
const alignmentPlugin = createAlignmentPlugin()
const toolbarPlugin = createInlineToolbarPlugin({
  structure: [
    BoldButton,
    ItalicButton,
    UnderlineButton,
    BlockquoteButton,
    linkPlugin.LinkButton,
  ],
})
const decorator = composeDecorators(
  resizeablePlugin.decorator,
  alignmentPlugin.decorator,
  focusPlugin.decorator,
  blockDndPlugin.decorator,
)

const imagePlugin = createImagePlugin({ decorator })

export const modifiers = {
  addImage: imagePlugin.addImage,
}
export const { AlignmentTool } = alignmentPlugin
export const { InlineToolbar } = toolbarPlugin
export default [
  blockDndPlugin,
  focusPlugin,
  resizeablePlugin,
  alignmentPlugin,
  imagePlugin,
  toolbarPlugin,
  linkPlugin,
]



// WEBPACK FOOTER //
// ./src/components/sitewide/RichTextEditor/plugins/index.js